var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg5Nej = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 83,
  height: 22,
  fill: "none",
  viewBox: "0 0 83 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M8.77 8.027H5.661a.013.013 0 0 1-.012-.013V5.66a.012.012 0 0 1 .012-.013h7.418A5.93 5.93 0 0 0 15.875.422c0-.155 0-.293.011-.422H.013A.013.013 0 0 0 0 .013v13.65l.001.005.007.007H8.77a1.34 1.34 0 0 1 1.331 1.461 1.386 1.386 0 0 1-1.403 1.212H.162a.013.013 0 0 0-.013.013v5.624l.003.009a.01.01 0 0 0 .01.003H8.59a6.987 6.987 0 1 0 .18-13.972z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000960",
  d: "m28.558 21.873-6.278-6.295v6.295h-3.493V8.577h1.422l6.295 6.277V8.577h3.493v13.299z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000960",
  d: "M32.674 8.576h8.263v2.89H36.17v2.164h4.22v2.943h-4.22v2.447h4.767v2.855h-8.263z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#000960",
  d: "M51.4 17.333c-.053 3.071-2.607 4.54-5.196 4.54a6.37 6.37 0 0 1-3.776-1.383c.425-.426 1.277-1.277 2.536-2.572a1.81 1.81 0 0 0 1.364.444 1.47 1.47 0 0 0 1.578-1.543V8.576H51.4z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#000960",
  d: "M54.857 19.036a1.375 1.375 0 0 1 1.4 1.402 1.4 1.4 0 1 1-2.801 0 1.373 1.373 0 0 1 1.4-1.402"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#000960",
  d: "M66.896 12.972a3.1 3.1 0 0 0-2.234-.869 3.122 3.122 0 1 0 2.234 5.355l2.483 2.447a6.648 6.648 0 1 1-4.717-11.33 6.58 6.58 0 0 1 4.681 1.932z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#000960",
  d: "M77.182 18.379h5.142v3.493h-11.19l5.657-9.788h-5.32V8.576h11.366z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0,
  x2: 15.886,
  y1: 11,
  y2: 11,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0045FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0084FF"
})))));
export default Svg5Nej;